import { useDeleteAccount } from '../../hooks/use-delete-account'

export const useConfirmWithoutSubscriptionCard = () => {
  const { isDeletingAccount, handleClickDeleteButton } = useDeleteAccount()

  const isLoadingDeleteButton = isDeletingAccount
  const isDisabledCancelButton = isDeletingAccount

  return {
    isLoadingDeleteButton,
    isDisabledCancelButton,
    handleClickDeleteButton,
  }
}
